<app-loader *ngIf="isLoading"></app-loader>

<div>
    <h4 class="q-heading mb-4">
        <span><img [src]="'IMAGES.BACKARROW'|translate" (click)="goBack()" alt="" class="me-2" /></span>
        {{ "MANAGEUSER.CHANGEOWNERSHIP" | translate }}
    </h4>
</div>
<div class="bg-white p-3 p-md-4 mb-5 border-radius-6" id="transferOwner">
    <div class="col mb-5 mt-2">
        <ng-container>
            <form [formGroup]="transferOwnershipForm" (ngSubmit)="onTransferOwnership()">
                <div class="form-div">
                    <div>
                        <span class="q-tab-content-title"
                            style="font-size: 16px;">{{"MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CURRENTUSER" |
                            translate}} {{":"}}</span>
                        <span class="q-tab-content-desc" style="font-size: 16px;">{{ currentDeviceOwner?.name }}
                            {{currentDeviceOwner?.lastName}}</span>
                    </div>
                    <div class="mt-4">
                        <label for="" class="q-form-label" style="font-size: 16px">{{
                            "MANAGEUSER.DEVIEDETAILS" | translate
                            }}</label>
                        <div class="table-responsive mb-3" id="deviceTable">
                            <table class="table activity-table device-row mb-0" aria-describedby="Summary">
                                <thead class="activity-header" style="font-size: 16px;">
                                    <tr>
                                        <th>
                                            <div class="" style="padding-left: 24px;width: 20px;padding-right: 0;">
                                                <input type="checkbox" id="option_checkbox" style="accent-color: 
                                                #F16522;" [checked]="allChecked" (change)="
                              onDeviceClick(
                                $event,
                                getUserDeviceData,
                                'multiple'
                              )
                            " class="align-middle" />
                                            </div>
                                        </th>
                                        <th style="font-size: 16px; align-content: center;">
                                            {{ "MANAGEUSER.DEVICENAME" | translate }}
                                        </th>
                                        <th style="font-size: 16px;">
                                            {{ "MANAGEUSER.DEVICETYPE" | translate }}
                                        </th>
                                        <th style="font-size: 16px;">
                                            {{ "MANAGEUSER.PRODUCTKEY" | translate }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="
                        let item of getUserDeviceData;
                        let i = index;
                        trackBy: trackByFn
                      " style="font-size: 14px;">
                                        <td>
                                            <div class="" style="padding-left: 24px;width: 20px;padding-right: 0;">
                                                <input style="accent-color: #F16522;" type="checkbox"
                                                    id="option_checkbox" [checked]="individualChecked"
                                                    (change)="onDeviceClick($event, item, 'single')" name="ritem"
                                                    class="align-middle" />
                                                <label for="ritema"></label>
                                            </div>
                                        </td>
                                        <td>
                                            {{ item.deviceName | translate }}
                                        </td>
                                        <td>
                                            {{ item.deviceType | translate }}
                                        </td>
                                        <td>
                                            {{ item.productKey | translate }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-md-4">
                            <label class="q-form-label tooltips" style="font-size: 16px;"> {{ "MANAGEUSER.SELECTNEWUSER"
                                | translate }}</label>
                            <ng-select #transferUserSelect class="bg-transparent custom w-100" bindLabel="name"
                                bindValue="id" [clearable]=false [searchable]=false [items]="getTransferOwnershipUser"
                                placeholder="{{'MANAGEUSER.SELECTUSEROWNER'| translate}}" [ngModel]="userId"
                                (ngModelChange)="transferOwnershipUsername($event)" formControlName="assignedUserId">
                                <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                                    <span>{{ item.name }}</span>
                                </ng-template>
                                <ng-template class="text-truncate custom" ng-option-tmp let-item="item"
                                    let-index="index">
                                    <div class="d-flex justify-content-left">
                                        <span class="pt-1"><img *ngIf="item?.avatarUrl !=null" [src]="item?.avatarUrl"
                                                alt="avatar" width="35" height="35" class="rounded-50 me-1" />
                                            <img *ngIf="item?.avatarUrl ==null || item?.avatarUrl == undefined"
                                                [src]="'MYACCOUNT.AVATARPNG' | translate" alt="avatar" width="35"
                                                height="35" class="rounded-50 me-1" />
                                        </span>
                                        <div class="ps-1">
                                            <div class=" text-truncate transferUserName" title={{item?.name}}>{{
                                                item?.name.length > 20 ? item?.name.slice(0,20) + "..." :
                                                item?.name}}</div>
                                            <div class="text-truncate transferRoleName">{{ item.roleType | translate}}
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex align-items-center mt-3">

                            <button type="button" class="q-form-white-submit me-2" (click)="goBack()">
                                {{ "LOGIN.CANCEL" | translate }}
                            </button>

                            <button type="submit" class="submit-btn bg-orgclr" [ngClass]="
        transferOwnershipForm.invalid ||
        deviceIdList.size === 0 ||
        transferOwnershipForm.controls['assignedUserId'].value === ''
          ? 'q-invalid-button'
          : ''
      " [disabled]="
        transferOwnershipForm.invalid ||
        deviceIdList.size === 0 ||
        transferOwnershipForm.controls['assignedUserId'].value === ''
      ">
                                {{ "MYACCOUNT.SAVE" | translate }}
                            </button>

                        </div>
                    </div>


                </div>
            </form>
        </ng-container>
    </div>
    <div class="modal" id="ChangedOwnerSuccess" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div
                class="modal-content border-none shadow-lg p-4 rounded-25 relative w-100 pointer-events-auto bg-white outline-none">
                <ng-container *ngIf="isTransferOwnershipSuccess">
                    <div class="">
                        <div class="text-center">
                            <div>
                                <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
                            </div>
                            <h5 class="q-modal-heading fw-bold mt-4">
                                {{
                                "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.OWNERSHIPTRANSFERSUCCESS"
                                | translate
                                }}
                            </h5>
                            <p class="text-xs">
                                {{
                                "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICEOWNERSHIPTO"
                                | translate
                                }}
                                {{ getUser }}
                                {{
                                "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.SUCCESSFULLY" | translate
                                }}.
                            </p>
                            <button class="w-25 submit-btn bg-orgclr" (click)="closeSuccessModal()">
                                {{ "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DONE" | translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>